import "./side-by-side-section-intro.scss";

import { ReactNode, useId } from "react";
import { EditAttributes } from "design-system/types/types";
import cn from "clsx";

export interface SideBySideSectionIntroProps {
  variant?: "ordered" | "unordered";
  title?: ReactNode;
  text?: ReactNode;
  subtitle?: ReactNode;
  anchorId?: string;
  HeadingLevel?: "h2" | "h3";
  HeadingLevelItem?: "h2";
  editAttributes?: {
    title?: EditAttributes;
    subtitle?: EditAttributes;
    text?: EditAttributes;
  };
}

export function SideBySideSectionIntro({
  variant,
  title,
  subtitle,
  text,
  anchorId,
  HeadingLevelItem = "h2",
  editAttributes,
}: SideBySideSectionIntroProps) {
  const containerClass = cn(
    "hbs-global-align-full",
    "hbs-component--side-by-side-section-intro",
    "hbs-collapse-bottom-margin",
    text
      ? "hbs-component--side-by-side-section-intro--text"
      : "hbs-component--side-by-side-section-intro--no-text",
  );
  const generatedId = useId().replace(/:/g, "").toLowerCase();
  const titleId = anchorId || generatedId;

  return (
    <div className={containerClass} data-region="cb__section-intro-text">
      <div className="hbs-side-by-side-section-intro__wrapper">
        <div className="hbs-side-by-side-section-intro">
          {variant === "ordered" && (
            <div className="hbs-side-by-side-section-intro__order">
              <div className="hbs-side-by-side-section-intro__order-number" />
            </div>
          )}

          <div className="hbs-side-by-side-section-intro-text__content">
            {(title || subtitle) && (
              <div
                className="hbs-side-by-side-section-intro-text__title"
                id={titleId}
                tabIndex={-1}
              >
                {title && (
                  <HeadingLevelItem
                    {...editAttributes?.title}
                    className="hbs-text-h4"
                  >
                    {title}
                  </HeadingLevelItem>
                )}

                {subtitle && (
                  <div
                    {...editAttributes?.subtitle}
                    className="hbs-side-by-side-section-intro-text__subtitle hbs-text-h4"
                  >
                    {subtitle}
                  </div>
                )}
              </div>
            )}

            {text && (
              <div className="hbs-side-by-side-section-intro-text__content-wrapper">
                <div
                  {...editAttributes?.text}
                  className="hbs-side-by-side-section-intro-text__text"
                >
                  {text}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
